import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconColumnPicker = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 30,
	height: 30,
	fill: "#8f8882",
	fillRule: "evenodd",
	viewBox: "0 0 30 30",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2414,389h-2V367h-7v22h9a2,2,0,0,1-2,2h-26a2,2,0,0,1-2-2h9V367h-7v22h-2V367h0v-4a2,2,0,0,1,2-2h26a2,2,0,0,1,2,2v4h0v22Zm-11-22h-8v22h8V367Z",
		transform: "translate(-2384 -361)"
	})
});
export default SvgIconColumnPicker;
